import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import isFunction from "lodash/isFunction"
import planResourceTypeModel from "src/models/plan/models/resourceType"
import collection from "src/hocs/collection"

const configurator = ({ planId }) => ({
  engine: entity,
  to: `planResourceTypes`,
  model: planResourceTypeModel(planId),
  query: {
    limit: -1,
  },
})

export default config =>
  compose(
    collection(props => ({
      ...configurator(props),
      ...(isFunction(config) ? config(props) : config),
    })),
  )
